import request from '../../utils/requests'
/** * Tag: WXClassNoticeConfig */
const baseUrl ="/api/WXClassNoticeConfig";

/** * 设置通知班级：分页 * @param {*} body * { *    ClassName Desc:班级 Required:false *    CourseId Desc:课程id Required:false *    IsOpen Desc:是否开启（1：开启，0：关闭,-1:全部） Required:false *    BranchId Desc:校区 Required:false *    OrgId Desc:后台使用 Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _paging(body) {  return request(baseUrl+'/paging',{    method: 'POST',    body: body,  });
}

/** * 关闭班级通知 * @param {*} body * { *    BranchId Desc:校区 Required:false *    ClassList Desc:通知列表 Required:false * } */async function _setClassCloseNotice(body) {  return request(baseUrl+'/setClassCloseNotice',{    method: 'POST',    body: body,  });
}

/** * 开启班级通知 * @param {*} body * { *    BranchId Desc:校区 Required:false *    ClassList Desc:通知列表 Required:false * } */async function _setClassOpenNotice(body) {  return request(baseUrl+'/setClassOpenNotice',{    method: 'POST',    body: body,  });
}

export default{  _paging,  _setClassCloseNotice,  _setClassOpenNotice}



// WEBPACK FOOTER //
// ./src/services/wXClassNoticeConfig.js